import {
  AppConfig,
  ChatBVProvider,
  ReportContextProvider,
} from '@ltvco/refresh-lib/ctx';
import { Stack, SxProps, Text } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import {
  ReportColumnContainer,
  CHATAI_GA4_EVENTS,
  SEARCH_TYPES,
  ReportResponse,
} from '@ltvco/refresh-lib/v2';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useContext } from 'react';

import { constants } from 'appConstants';
import { VehicleReport } from 'components/reports';

type ReportColumnProps = {
  onClose: () => void;
  permalink?: string;
  type?: string;
  reportData?: ReportResponse;
  sx?: SxProps;
};

export const ReportColumn = ({
  onClose,
  permalink,
  type,
  reportData,
  sx,
}: ReportColumnProps) => {
  const { isMobile } = useScreenSize();
  const { trackEventGA4 } = useContext(AppConfig);

  const handleReportRedirect = () => {
    trackEventGA4({
      event_name: CHATAI_GA4_EVENTS.name,
      type: CHATAI_GA4_EVENTS.report.type,
      sub_type: CHATAI_GA4_EVENTS.report.subTypes.open_report_in_new_tab,
    });
    if (type && permalink) {
      const reportUrl = `${constants.links.baseUrl}/report/${type}?permalink=${permalink}`;
      window.open(reportUrl, '_blank');
    }
  };

  return (
    <>
      <ReportColumnContainer
        direction="column"
        spacing={2}
        width={isMobile ? '100%' : '40%'}
        height="98%"
        sx={{
          ...sx,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          position="sticky"
          top={0}
          zIndex={1}
          padding="16px 20px"
          sx={{
            backgroundColor: 'background.paper',
          }}
        >
          <Text variant="body1" fontWeight="bold" color="text.primary">
            Vehicle Report
          </Text>
          <Stack direction="row" spacing={2}>
            <OpenInNewIcon
              sx={{ color: 'text.secondary', cursor: 'pointer' }}
              onClick={handleReportRedirect}
            />
            <CloseIcon
              onClick={onClose}
              sx={{ color: 'text.secondary', cursor: 'pointer' }}
            />
          </Stack>
        </Stack>
        <ChatBVProvider width="100%">
          {type === SEARCH_TYPES.VEHICLE && permalink && reportData && (
            <ReportContextProvider permalink={permalink} reportType="vehicle">
              <VehicleReport permalink={permalink} preloadedData={reportData} />
            </ReportContextProvider>
          )}
        </ChatBVProvider>
      </ReportColumnContainer>
    </>
  );
};
